import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';

//enum
import {ACTION_TYPE} from '../actions-types';
//types
import {
	ICustomizationTemplate,
	IEmailTemplate,
	IEmailTemplateResponse,
	ITemplate,
} from '@/utils/types/organization-communication.interface';
//services
import {CommunicationService} from '@/utils/services/organization-communication.services';
//helpers
import {getErrorResponse} from '@/utils/helpers';
import {EMAIL_TEMPLATE_TYPE} from '@/utils/enums';

export const createEmailTemplate = createAsyncThunk(
	ACTION_TYPE.CREATE_CUSTOMIZATION_TEMPLATE,
	async (reqBody: ICustomizationTemplate, {rejectWithValue}) => {
		try {
			await CommunicationService.createCustomizationTemplate(reqBody);
			return {success: true};
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getEmailTemplate = createAsyncThunk(
	ACTION_TYPE.GET_CUSTOMIZATION_TEMPLATES,
	async (reqBody: number, {rejectWithValue}) => {
		try {
			const organizationResponse: AxiosResponse<ICustomizationTemplate> =
				await CommunicationService.getCommunicationTemplate(reqBody);
			return organizationResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
export const getAllEmailTemplates = createAsyncThunk(
	ACTION_TYPE.GET_All_CUSTOMIZATION_TEMPLATES,
	async (eventId: number, {rejectWithValue}) => {
		try {
			const organizationResponse: AxiosResponse<ITemplate[]> = await CommunicationService.getAllTemplateTypes(eventId);
			return organizationResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getOneEmailTemplateByType = createAsyncThunk(
	ACTION_TYPE.GET_ONE_CUSTOMIZATION_TEMPLATES,
	async ({eventId, templateType}: {eventId: number; templateType: EMAIL_TEMPLATE_TYPE}, {rejectWithValue}) => {
		try {
			const organizationResponse: AxiosResponse<IEmailTemplateResponse> =
				await CommunicationService.getOneTemplateByType(eventId, templateType);
			return organizationResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const updateOneEmailTemplateByType = createAsyncThunk(
	ACTION_TYPE.UPDATE_ONE_CUSTOMIZATION_TEMPLATES,
	async ({templateType, reqBody}: {templateType: EMAIL_TEMPLATE_TYPE; reqBody: IEmailTemplate}, {rejectWithValue}) => {
		try {
			const organizationResponse: AxiosResponse<IEmailTemplateResponse> =
				await CommunicationService.updateOrCreateTemplate(templateType, reqBody);
			return organizationResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
